import React, { useLayoutEffect } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { ButtonToolbar } from 'reactstrap';
import Immutable from 'immutable';
import Content from '../../../layout/Content';
import { clearHoliday, getHoliday } from '../../../../actions';
import { HOLIDAY_PATH } from '../../../../config/paths';
import {
  breadcrumbsPropTypes,
  matchPropTypes,
} from '../../../common/resource/proptypes/CommonPropTypes';
import Loader from '../../../common/Loader';
import NoDataResource from '../../../common/resource/NoDataResource';
import HolidayBasicResource from './resource/HolidayBasicResource';
import EditButton from '../../../common/button/EditButton';
import DeleteHolidayButton from './DeleteHolidayButton';

const Holiday = ({
  match: {
    params: { id },
  },
  dispatchGetHoliday,
  dispatchClearHoliday,
  loading,
  holiday,
  breadcrumbs,
}) => {
  useLayoutEffect(() => {
    dispatchGetHoliday({ holidayId: id });
    return () => dispatchClearHoliday();
  }, []);

  let content;

  let toolbar;

  if (loading) content = <Loader />;
  else if (holiday.isEmpty())
    content = <NoDataResource returnPage={HOLIDAY_PATH} />;
  else {
    const holidayJson = holiday.toJS();
    toolbar = (
      <ButtonToolbar className="pull-right">
        <EditButton path={`${HOLIDAY_PATH}/${holidayJson.id}/edit`} />
        <DeleteHolidayButton holidayId={id} />
      </ButtonToolbar>
    );
    content = <HolidayBasicResource {...holidayJson} />;
  }

  return (
    <Content
      breadcrumbs={breadcrumbs}
      title="Feriado"
      content={content}
      toolbar={toolbar}
    />
  );
};

Holiday.propTypes = {
  dispatchGetHoliday: PropTypes.func.isRequired,
  dispatchClearHoliday: PropTypes.func.isRequired,
  loading: PropTypes.bool,
  holiday: PropTypes.instanceOf(Immutable.Map).isRequired,
  match: matchPropTypes.isRequired,
  breadcrumbs: breadcrumbsPropTypes.isRequired,
};

Holiday.defaultProps = {
  loading: false,
};

const mapStateToProps = ({ HumanResourcesUnit }) => ({
  breadcrumbs: [
    ...HumanResourcesUnit.UnitHome.get('breadcrumbs'),
    {
      text: 'Feriados',
      href: HOLIDAY_PATH,
    },
    {
      text: 'Ver',
      href: '',
    },
  ],
  holiday: HumanResourcesUnit.Holiday.getIn(['current', 'content']),
  loading: !HumanResourcesUnit.Holiday.getIn(['current', 'activity']).isEmpty(),
});

const mapDispatchToProps = {
  dispatchGetHoliday: getHoliday,
  dispatchClearHoliday: clearHoliday,
};

export default connect(mapStateToProps, mapDispatchToProps)(Holiday);